import React from 'react'

export type RadioOption = {
  value: string
  label: string
}

export default function Radio({
  onChange,
  value,
  options,
}: {
  onChange: (_: React.ChangeEvent<HTMLInputElement>) => void
  value: string
  options: RadioOption[]
}): React.ReactNode {
  return (
    <>
      {options.map(option => (
        <div key={option.value} className="flex flex-row gap-2 items-center">
          <input
            id={option.value}
            value={option.value}
            type="radio"
            checked={value === option.value}
            onChange={onChange}
            className="text-brand cursor-pointer h-4 w-4 bg-brand"
          />
          <label
            htmlFor={option.value}
            className="cursor-pointer"
          >
            {option.label}
          </label>
        </div>
      ))}
    </>
  )
}
